module.exports = __webpack_public_path__ + "img/event-banner-04.063257ee.jpg";